import { useCircleV4OptIn } from "react/hooks/useCircleV4OptIn";

import { PreviewBarComponent } from "./PreviewBarComponent";
import { usePreviewBarContent } from "./usePreviewBarContent";

export const PreviewBar = () => {
  const { shouldShowPreviewEnabledBar } = useCircleV4OptIn();
  const { hasCodeSnippets, previewBarText, previewBarCtaContent } =
    usePreviewBarContent();

  if (!shouldShowPreviewEnabledBar) return null;

  return (
    <PreviewBarComponent
      previewBarText={previewBarText}
      previewBarCtaContent={previewBarCtaContent}
      showActivationButton={!hasCodeSnippets}
    />
  );
};
